import React, { useCallback, useMemo } from "react";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { SSH_User } from "@danishagro/sharedShop/src/interfaces/user.interface";
import { useBottomSheet } from "@danishagro/shared/src/contexts/bottomSheet/bottomSheet.context";
import { _UserDetails } from "../UserItem/components/UserDetails.component";
import S from "./UserItem.module.scss";

interface UserItemProps extends SSH_User {
    onRemove?: () => void;
    onEdit?: () => void;
    noFooterAction?: boolean;
}

export const _UserItem = (props: UserItemProps) => {
    const { getDictionaryItem, getDictionaryString } = useTranslations();
    const { presentBottomSheet } = useBottomSheet();

    const userName = useMemo(() => {
        return props.firstName || props.lastName
            ? `${props.firstName} ${props.lastName}`
            : getDictionaryString("unnamed");
    }, [getDictionaryString, props.firstName, props.lastName]);

    const openInfoBottomSheet = useCallback(() => {
        presentBottomSheet(
            <_UserDetails
                currentRole={props.roleAlias}
                customerNumbers={props.customerNumbers}
                userName={userName}
                invitedBy={props.invitedBy}
                userId={props.userId}
                onRemove={props.onRemove}
                onEdit={props.onEdit}
                noFooterAction={props.noFooterAction}
            />,
            {
                id: "user-details",
                headerTitle: userName,
                contentPadding: true,
                contentPaddingLarge: true,
                snapPoints: ({ maxHeight }) => [maxHeight - 50],
            }
        );
    }, [
        presentBottomSheet,
        props.customerNumbers,
        props.invitedBy,
        props.onEdit,
        props.onRemove,
        props.roleAlias,
        props.userId,
        userName,
        props.noFooterAction,
    ]);

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            openInfoBottomSheet();
        }
    };

    return (
        <div
            onClick={openInfoBottomSheet}
            onKeyDown={handleKeyPress}
            role="button"
            tabIndex={0}
            className={S.userItem}
        >
            <div className={S.roletype}>
                {getDictionaryItem(props.roleAlias, {
                    uppercaseFirst: true,
                })}
            </div>
            <div className={S.name}>{userName}</div>
        </div>
    );
};
